import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class SessionService {

    constructor(){
        this.adresse = new AdresseIP()
    }

    getAuthHeaders() {
        const storedToken = localStorage.getItem('accessToken');
        if (!storedToken) return {};

        try {
            const token = JSON.parse(storedToken);
            return token ? { Authorization: `Bearer ${token}` } : {};
        } catch (error) {
            return { Authorization: `Bearer ${storedToken}` };
        }
    }

    getAll() {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/session-cenou"
        return axios.get(url, {
            headers: this.getAuthHeaders()
        }).then(res => res.data)
        
    }
    create(newSession) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/session-cenou"
        return axios.post(url,newSession, {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    }
    update(idSession ,newSession) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/session-cenou/"
        return axios.put(url+idSession, newSession, {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    }
    delete(idSession) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/session-cenou/"
        return axios.patch(url+idSession, {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    }
    getSessionDirection(idDirection) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/session-cenou?idDirection="+idDirection
        return axios.get(url, {
            headers: this.getAuthHeaders()
        }).then(res => res.data)
    }

}